import { createBrowserHistory } from "history"

const apphistory = createBrowserHistory()

export default apphistory